<div class="contenedor-spinner" [style.width.px]="size" [style.height.px]="size">
  <img class="spinner-sombra" src="assets/icons/Spinner-editable-curva-sombra.svg" alt="" />
  <img class="spinner-color" src="assets/icons/Spinner-editable-curva.svg" alt="" />
</div>
